/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useRef, useState } from "react";
import { styled } from "@mui/material/styles";
import {
    Box,
    Grid,
    GridProps,
    IconButton,
    InternalStandardProps,
    Typography,
} from "@mui/material";
import { Layout } from "../Layout";
import { AppHeader } from "JS/React/Components/AppHeader";
import {
    useGlobalGifts,
    useVideoGifts,
    useSendGifts,
    useReceivedMemberVideoGifts,
    useReceivedProspectVideoGifts,
    useRemainingQuantity,
    useProspectingUser,
} from "JS/React/Hooks/Gifts";
import {
    useAvailableCredits,
    usePurchaseByCard,
    useAddContentToCart,
    useRedeemByCredits,
    useRedeemGiftByCredits,
} from "JS/React/Hooks/Purchase";
import {
    useGlobalVideoDetails,
    useGlobalVideos,
    useVideoDetails,
    useVideos,
} from "JS/React/Hooks/Video";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import {
    FirebaseEventAction,
    EventCategories,
    EventNames,
    EventActions,
    Content,
    ContentWithMedia,
    PurchasableGift,
    ReceivedGift,
    GiftWithMedia,
    ContentType,
    ContentMedia,
    contentTypeOf,
} from "JS/Models";
import { getThumbnailUrl } from "JS/React/Hooks/Common/ImageUpload";
import { MediaPlayer } from "JS/React/Components/MediaPlayer";
import { GraphicEq as GraphicEqIcon } from "@mui/icons-material";
import { AppButton } from "JS/React/Components/AppButton";
import moment from "moment";
import { ContentPurchase } from "JS/React/Components/ContentPurchase/ContentPurchase";
import { PaymentMethod } from "JS/React/Components/ContentPurchase/PaymentMethodRadio";
import { useSnackbar } from "JS/Helpers/Snackbar";
import { GiftQuantity } from "JS/React/Components/ContentPurchase/GiftQuantity";
import {
    isSufficientCreditAvailable,
    invalidContentSize,
    isRedeemable,
    hasAttachSku,
    getValidNumber,
    bytesToMB,
} from "JS/Helpers";
import { SelectMembersDialog } from "JS/React/Components/ContentPurchase/SelectMembersDialog";
import { AppCircularProgress } from "JS/React/Components/Progress/AppCircularProgress";
import { messaging } from "JS/Helpers/UserMessaging";
import { useFirebaseLogger } from "JS/React/Hooks/Firebase";
import {
    useCheckContentDownloaded,
    useOwnedBlobUrl,
    useHandleMediaGifts,
    useSearchedLosMembers,
} from "JS/React/Hooks/Media";
import { AppBackdropProgress } from "JS/React/Components/Progress/AppBackdropProgress";
import { useRouting } from "JS/React/Hooks/Routes";
import { useGlobalNavStack } from "JS/React/Hooks/NavStack";
import {
    DownloadStatus,
    addToDownloadQueue,
    getDownloadQueueLength,
    isInDownloadQueue,
} from "JS/Helpers/ContentDownloadHelper";
import { getDexieConnectionRefresh } from "JS/Database/Dexie";
import { useAppDispatch, useAppSelector } from "JS/Redux/Store";
import { AppConfimationDialog } from "JS/React/Components/AppConfirmationDialog";
import { config } from "JS/Config";
import { setDownloadedContentNids } from "JS/Redux/download";
import {
    useGetFavorites,
    useGlobalFavorites,
    useMarkFavorites,
    useUnMarkFavorites,
} from "JS/React/Hooks/Favorites";
import { PLAYER_PROGRESS_INTERVAL, appConstants } from "JS/Helpers/Constants";
import {
    AddToDownloadOptions,
    GiftsTypes,
    MiniPlayerOptions,
} from "JS/Models/Common";
import {
    useContentPlayingHandlers,
    usePlayerHandlers,
} from "JS/React/Hooks/MediaPlayer";
import {
    useDisclosureGate,
    usePublishDisclosurePlaying,
} from "JS/React/Hooks/Disclosure";
import { useDisclosureSequence } from "JS/React/Hooks/DisclosureSequence";
import { DisclosureBadge } from "JS/React/Components/MediaPlayer/DisclosureBadge";
import { useDownloadingStatusWithSize } from "JS/React/Hooks/Downloading";
import { DownloadDisabled } from "JS/React/Components/DownloadDisabled";
import { DownloadWarningDialog } from "JS/React/Components/DownloadWarningDialog";
import { useMiniPlayerHandlers } from "JS/React/Hooks/MiniPlayer";
import { PlayerActionBtns } from "JS/React/Components/MediaPlayer/PlayerActionBtns";
import {
    useIsResumingVideo,
    useResumeRecentlyVideo,
} from "JS/React/Hooks/ResumeRecently";
import { getCurrentUrl } from "JS/Helpers/MiniPlayerHelper";
import { AppDownloadingIcons } from "JS/React/Components/Icon/AppDownloadingIcons";
import { ActionIcon } from "JS/React/Components/Icon/ActionIcon";
import { AppMenuListing } from "JS/React/Components/AppMenuListing";
import {
    SentGiftType,
    getPlayerPlayedTimeToLog,
    toSentGift,
} from "JS/Models/Firebase/GiftDashboard";
import { useGiftDashboard } from "JS/React/Hooks/Firebase/GiftDashboard";
import { VideoCategoryTitle } from ".";
import { RenderIf } from "JS/React/Components/Wrapper/RenderIf";
import qs from "qs";
import {
    AttachSkuMenu,
    convertToAttachSkuArray,
} from "../AttachedSku/AttachSkuMenu";
import { PurchaseAndSkuInfoGrid } from "../PurchaseAndSkuInfoGrid";

export const VideoContentDetail = (props: VideoContentDetailProps) => {
    const { className, ...rest } = props;

    const navigate = useNavigate();
    const location = useLocation();
    const params: any = useParams();
    const { linkProvider } = useRouting();
    const { homeStack, setGlobalVideosStack } = useGlobalNavStack();
    const { contentId, categoryId, isFavorite, isAutoPlay } = params;
    const { enqueueSnackbar } = useSnackbar();

    //For Downloaded Video
    const [downloadedVideoUrl, setDownloadedVideoUrl] = useState<string>("");
    const [isVideoDownloaded, setIsVideoDownloaded] = useState<boolean>(false);
    const [addedToDownloadQueue, setAddedToDownloadQueue] =
        useState<boolean>(false);
    const [isOpenConfirmDailog, setIsOpenConfirmDailog] = useState(false);
    const [sizeOfContent, setSizeOfContent] = useState(0);
    const [mediaSizeBytes, setMediaSizeBytes] = useState<number>(undefined);
    const [deleteLoader, setDeleteLoader] = useState(false);
    const [queueLimitReached, setQueueLimitReached] = useState(false);
    const [videoURL, setVideoURL] = useState("");
    const [currentPlayingState, setCurrentPlayingState] = useState(
        isAutoPlay === "true",
    );

    const [playing, setPlaying] = useState(false);

    const { handlePlayerPause, handlePlayerPlay } = useContentPlayingHandlers(
        (val) => {
            setPlaying(val);
            setCurrentPlayingState(val);
        },
    );
    //For Gift Icon
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const [thumbnail, setThumbnail] = useState<string>(null);
    const inProgressNid = useAppSelector(
        (state) => state.download.inProgressNid,
    );
    const downloadedContentNids = useAppSelector(
        (state) => state.download.downloadedContentNids,
    );
    const dispatch = useAppDispatch();

    const { videos, setGlobalVideos } = useGlobalVideos();

    const { videoDetails } = useGlobalVideoDetails(contentId);

    const { loading: videosLoading } = useVideos();
    const { isProsUser, loading: loadingProsStatus } = useProspectingUser();

    const {
        purchasableMemberVideos,
        purchasableProspectVideos,
        receivedMemberVideos,
        receivedProspectVideos,
    } = useGlobalGifts();

    const {
        loading: receivedMemberVideoGiftsLoading,
        loaded: receivedMemberGiftsLoaded,
        isGift,
    } = useReceivedMemberVideoGifts(
        !!receivedMemberVideos && receivedMemberVideos.length > 0,
    );

    const {
        loading: receivedProspectVideoGiftsLoading,
        loaded: receivedProspectGiftsLoaded,
    } = useReceivedProspectVideoGifts(
        !isProsUser || receivedProspectVideos?.length > 0,
    );
    const queryParams = useQueryParams();

    const { isMixedContent, scrollTo = "0", filePath } = queryParams;

    const video: ContentWithMedia | GiftWithMedia = useMemo(() => {
        let withoutMedia = {} as Content | ReceivedGift;
        if (videos?.filter((video) => video.nid === contentId).length > 0) {
            withoutMedia = videos?.find((video) => video.nid === contentId);
        } else if (
            receivedMemberVideos?.filter((video) => video.nid === contentId)
                .length > 0
        )
            withoutMedia = receivedMemberVideos?.find(
                (video) => video.nid === contentId,
            );
        else
            withoutMedia = receivedProspectVideos?.find(
                (video) => video.nid === contentId,
            );

        return {
            ...withoutMedia,
            ...videoDetails,
        };
    }, [
        videos,
        receivedMemberVideos,
        contentId,
        receivedProspectVideos,
        videoDetails,
    ]);

    const giftDashboardData = useMemo(() => {
        return toSentGift(video);
    }, [video]);

    const analyticsData = (action?: EventActions) => {
        const { sku_id: skuId, nid: nId, title: contentTitle } = video;
        return {
            action,
            contentTitle,
            skuId,
            nId,
            category: video?.isReceived
                ? EventCategories.GIFT_VIDEOS
                : EventCategories.VIDEOS,
        };
    };

    const {
        playerRef,
        setIsReady,
        handleRecentlyPlayed,
        handleContentCompleted,
        onMediaPlayerReady,
        onPlayerProgress,
    } = useResumeRecentlyVideo(video, contentId, setCurrentPlayingState);

    const isFavoritesTab = isFavorite && JSON.parse(isFavorite?.toLowerCase());

    const { favNids } = useGlobalFavorites();
    const { loading: favoritesLoading } = useGetFavorites(!!favNids?.length);

    const isFavoriteVideo = favNids?.includes(video?.nid);

    const { markFavContentNid, loading: markFavLoading } = useMarkFavorites();
    const { unMarkFavContentNid, loading: unMarkFavLoading } =
        useUnMarkFavorites();

    const videoContentType: ContentType =
        "content_item_type_name" in video
            ? (video.content_item_type_name as ContentType)
            : "Video";

    const { loading: detailLoading } = useVideoDetails(
        contentId,
        videoContentType,
    );

    const { loading: memberGiftsLoading } = useVideoGifts(
        "GiftVideo",
        !!purchasableMemberVideos && purchasableMemberVideos.length > 0,
    );
    const { loading: prospectGiftsLoading } = useVideoGifts(
        "GiftProsVideo",
        !!purchasableMemberVideos && purchasableMemberVideos.length > 0,
    );
    const videoGiftsLoading = memberGiftsLoading || prospectGiftsLoading;

    const {
        availableCredits,
        loading: availableCreditsLoading,
        getAvailableCredits,
    } = useAvailableCredits();
    const { redeemByCredits, loading: redeemingContent } = useRedeemByCredits();
    const { redeemGiftByCredits, loading: redeemingGiftContent } =
        useRedeemGiftByCredits();

    const { addToCart, cart } = useAddContentToCart();
    const { purchaseByCard, loading: purchasingContent } = usePurchaseByCard();
    const [isPurchasingFailed, setIsPurchasingFailed] = useState(false);

    useCheckContentDownloaded(
        video?.nid,
        inProgressNid,
        "video",
        setIsVideoDownloaded,
        setDownloadedVideoUrl,
    );

    // video never reaches the mini-player, so this screen owns the blob url outright
    useOwnedBlobUrl(downloadedVideoUrl);

    const [mediaURL, setMediaURL] = useState<string>("");
    const [purchaseEnabled, setPurchaseEnabled] = useState<boolean>(false);
    const [giftItem, setGiftItem] = useState<PurchasableGift>(null);
    const [paymentMethod, setPaymentMethod] = useState<PaymentMethod>(
        video?.is_redeemable_by_tokens &&
            availableCredits !== 0 &&
            availableCredits >= +video?.number_of_tokens
            ? PaymentMethod.MY_CREDITS
            : PaymentMethod.CARD,
    );

    const videoGiftSku = (giftType: GiftsTypes) => {
        if (!video || video?.isReceived) return "";

        return giftType === GiftsTypes.MEMBER
            ? "member_gift_sku" in video && video.member_gift_sku
            : "prospect_gift_sku" in video && video.prospect_gift_sku;
    };

    const {
        loading: quantityLoading,
        quantity,
        fetch: fetchQuantity,
    } = useRemainingQuantity(
        "member_gift_sku" in video && video.member_gift_sku,
        "prospect_gift_sku" in video && video.prospect_gift_sku,
    );

    const {
        activeGiftItem,
        dialogs,
        selectedMembers,
        anchorSendGift,
        openSendGift,
        setDialogs,
        setActiveGiftItem,
        onQuantityChange,
        onSendContent,
        onToggleItemSelect,
        onCloseSelectMembers,
        setAnchorSendGift,
        onGiftSendMenuItem,
        onSendItemsClose,
    } = useHandleMediaGifts(
        quantity.memberQuantity,
        setIsReady,
        setPurchaseEnabled,
        setGiftItem,
    );

    useEffect(() => {
        const reqContent = activeGiftItem?.giftPurchasedEnabled
            ? giftItem
            : video;
        setPaymentMethod(
            isRedeemable(
                reqContent,
                availableCredits,
                activeGiftItem?.giftPurchasedEnabled
                    ? `${giftItem?.content_price}`
                    : "0",
            )
                ? PaymentMethod.MY_CREDITS
                : PaymentMethod.CARD,
        );
    }, [
        video?.is_redeemable_by_tokens,
        activeGiftItem?.giftPurchasedEnabled,
        availableCredits,
        video?.number_of_tokens,
    ]);

    //Player Resume States
    const { handleChangeSeek } = usePlayerHandlers(playerRef);
    const { searchLosResults, searchQueryLos, setSearchQueryLos } =
        useSearchedLosMembers();

    //Send Gift
    const { sendGiftToUser, loading: sendingGifts } = useSendGifts();
    const { logFirebaseEvent } = useFirebaseLogger();

    const isMediaPlayable =
        video?.is_purchased ||
        video?.publish_free === "1" ||
        video?.publish_free == "true" ||
        video?.isReceived;

    const videoLoaded =
        videosLoading &&
        receivedProspectGiftsLoaded &&
        receivedMemberGiftsLoaded;

    const getDashboardActionDetails = () => {
        return getPlayerPlayedTimeToLog(playerRef);
    };

    const isReceivedMemberVideo = isGift(contentId);

    const { miniPlayer, onClickMiniPlayer } = useMiniPlayerHandlers();

    const isResuming = useIsResumingVideo(contentId);

    const disclosure = useDisclosureGate({
        disclosure: video?.disclosure,
        skuId: video?.sku_id,
        nId: video?.nid,
        contentType: contentTypeOf(video, "Video"),
    });

    const [isLoop, setLoop] = useState(false);

    const sequence = useDisclosureSequence({
        contentUrl: videoURL,
        loop: isLoop,
        disclosure: video?.disclosure,
        startUrl: disclosure.startUrl,
        endUrl: disclosure.endUrl,
        resolving: disclosure.resolving,
        skipStart: isResuming,
        autoPlay: isAutoPlay === "true" && currentPlayingState,
        analytics: disclosure.analytics,
    });

    usePublishDisclosurePlaying(sequence.isDisclosure);

    const handleSequencePlay = () => {
        sequence.onPlay();
        if (!sequence.isDisclosure) handlePlayerPlay();
    };

    const handleSequencePause = () => {
        sequence.onPause();
        if (!sequence.isDisclosure) handlePlayerPause();
    };

    const handleSequenceStarted = () => {
        if (!sequence.isDisclosure) handleVideoStartedPlaying();
    };

    const blockedMessage =
        disclosure.blocked || sequence.clipFailed
            ? disclosure.message
            : undefined;

    const { logGiftOpen, logGiftCompleted } = useGiftDashboard(
        giftDashboardData,
        SentGiftType.VIDEO,
        video && "sender" in video ? video?.sender?.member_id : null,
        isReceivedMemberVideo && playing && !miniPlayer?.url,
        getDashboardActionDetails,
    );

    const media = useMemo((): ContentMedia | null => {
        if (!video) return null;

        if (video?.media?.length) {
            return video.media[0];
        }
        const { image_url_prefix, image_url_postfix, image_file_name } = video;

        return {
            media_url_prefix: image_url_prefix,
            media_url_postfix: image_url_postfix,
            media_file_name: image_file_name,
            media_bucket_name: "",
            media_title: "",
            position: 0,
        };
    }, [video]);

    useEffect(() => {
        if (video && !detailLoading && media) {
            if (
                !media.media_bucket_name ||
                !media.media_url_postfix ||
                !media.media_file_name
            ) {
                return;
            }

            getDexieConnectionRefresh()
                .videos.get(`${config.user.memberId}-${video.nid}`)
                .then((res) => {
                    if (res) {
                        setIsReady(false);
                        setIsVideoDownloaded(true);
                        setAddedToDownloadQueue(false);
                        setDownloadedVideoUrl(URL.createObjectURL(res.blob));
                    }
                })
                .catch((err) => {
                    setIsReady(true);
                    setIsVideoDownloaded(false);
                });

            logFirebaseEvent(
                video?.isReceived
                    ? EventNames.GIFT_VIDEO_OPENED
                    : EventNames.VIDEO_OPENED,
                analyticsData(EventActions.OPEN),
            );

            fetchThumbnails();
            if (media.media_url) {
                setMediaURL(media.media_url);
                setSizeOfContent(bytesToMB(media.media_size || 0));
                setMediaSizeBytes(media.media_size || 0);
            }
        }
    }, [video?.media, detailLoading]);

    useEffect(() => {
        if (isReceivedMemberVideo && video) logGiftOpen();
    }, [video?.nid, isReceivedMemberVideo]);

    useEffect(() => {
        let interval;
        if (video && (inProgressNid === video?.nid || addedToDownloadQueue)) {
            const { nid } = video;
            interval = setInterval(() => {
                if (!isInDownloadQueue(nid)) {
                    setAddedToDownloadQueue(false);
                }
                getDexieConnectionRefresh()
                    .videos.get(`${config.user.memberId}-${nid}`)
                    .then((res) => {
                        if (res) {
                            setIsReady(false);
                            setIsVideoDownloaded(true);
                            setAddedToDownloadQueue(false);
                            setDownloadedVideoUrl(
                                URL.createObjectURL(res.blob),
                            );
                        }
                    })
                    .catch((err) => {
                        setIsReady(true);
                        setIsVideoDownloaded(false);
                    });

                if (isVideoDownloaded) {
                    clearInterval(interval);
                }
            }, 5000);
        }
        return () => {
            if (interval) {
                clearInterval(interval);
            }
        };
    }, [video, addedToDownloadQueue, isVideoDownloaded]);

    useEffect(() => {
        if (!video && videoLoaded) {
            navigate(-1);
        }
    }, [video, videoLoaded, navigate]);

    const fetchThumbnails = async () => {
        if (!thumbnail) {
            const thumb = await getThumbnailUrl(
                video.image_url_postfix,
                video.image_file_name,
            );

            setThumbnail(thumb);
        }
    };

    const handleVideoStartedPlaying = () => {
        if (video) {
            if (!isVideoDownloaded) {
                logFirebaseEvent(
                    video?.isReceived
                        ? EventNames.GIFT_VIDEO_LIVESTREAM
                        : EventNames.VIDEO_LIVE_STREAM,
                    analyticsData(EventActions.LIVE_STREAM),
                );
            } else {
                logFirebaseEvent(
                    video?.isReceived
                        ? EventNames.GIFT_AUDIO_PLAYED
                        : EventNames.AUDIO_PLAYED,
                    analyticsData(EventActions.PLAY),
                );
            }
            handleRecentlyPlayed();
        }
    };

    const purchaseText = useMemo(() => {
        if (activeGiftItem.giftPurchasedEnabled) {
            return paymentMethod === PaymentMethod.MY_CREDITS
                ? `Credits Required:  ${
                      +giftItem?.number_of_tokens * activeGiftItem?.quantity ||
                      0
                  }`
                : `Total: $ ${(
                      +giftItem?.content_price * activeGiftItem?.quantity || 0
                  ).toFixed(2)}`;
        } else {
            return paymentMethod === PaymentMethod.MY_CREDITS
                ? `Credits Required:  ${+video?.number_of_tokens}`
                : `Total: $ ${(+video?.content_price || 0).toFixed(2)}`;
        }
    }, [activeGiftItem, giftItem, paymentMethod]);

    const onBuyGiftContent = () => {
        if (
            paymentMethod === PaymentMethod.MY_CREDITS &&
            activeGiftItem?.giftPurchasedEnabled
        ) {
            const shortcut = shortcutGift();
            const firebaseEvent: Partial<FirebaseEventAction> = {
                nId: shortcut?.nid,
                contentTitle: shortcut?.title,
                category: EventCategories.GIFT_VIDEOS,
            };
            redeemGiftByCredits(
                shortcut?.sku_id,
                activeGiftItem?.quantity,
                firebaseEvent,
            )
                .then((response) => {
                    if (response?.status) {
                        if (activeGiftItem?.giftPurchasedEnabled) {
                            activeGiftItem?.title === GiftsTypes.MEMBER
                                ? fetchQuantity(
                                      (video as Content)?.member_gift_sku,
                                  )
                                : fetchQuantity(
                                      null,
                                      (video as Content)?.prospect_gift_sku,
                                  );
                        }
                        getAvailableCredits();
                        !activeGiftItem?.giftPurchasedEnabled &&
                            setPurchaseEnabled(false);
                        setIsPurchasingFailed(false);
                    }
                })
                .catch((err) => {
                    setIsPurchasingFailed(true);
                })
                .finally(() => {
                    setDialogs({
                        ...dialogs,
                        transactionConfirmation: false,
                        transactionComplete: true,
                    });
                });
        }
        if (
            paymentMethod === PaymentMethod.CARD &&
            activeGiftItem?.giftPurchasedEnabled
        ) {
            const shortcut = shortcutGift();
            const firebaseEvent: Partial<FirebaseEventAction> = {
                nId: shortcut?.nid,
                contentTitle: shortcut?.title,
                category: EventCategories.GIFT_VIDEOS,
            };
            purchaseByCard(
                cart.cartId,
                activeGiftItem.quantity,
                shortcut?.sku_id,
                firebaseEvent,
            )
                .then((response) => {
                    if (response?.status) {
                        setDialogs({
                            ...dialogs,
                            transactionConfirmation: false,
                            transactionComplete:
                                activeGiftItem?.giftPurchasedEnabled,
                        });
                        if (activeGiftItem?.giftPurchasedEnabled) {
                            activeGiftItem?.title === GiftsTypes.MEMBER
                                ? fetchQuantity(
                                      (video as Content)?.member_gift_sku,
                                  )
                                : fetchQuantity(
                                      null,
                                      (video as Content)?.prospect_gift_sku,
                                  );
                        }
                        !activeGiftItem?.giftPurchasedEnabled &&
                            setPurchaseEnabled(false);
                        setIsPurchasingFailed(false);
                    }
                })
                .catch((err) => {
                    setIsPurchasingFailed(true);
                });
        }
    };

    const onBuyContent = () => {
        if (paymentMethod === PaymentMethod.MY_CREDITS) {
            const firebaseEvent: Partial<FirebaseEventAction> = {
                nId: video?.nid,
                contentTitle: video?.title,
                category: EventCategories.VIDEOS,
            };
            redeemByCredits(video?.sku_id, firebaseEvent)
                .then((response) => {
                    if (response?.status) {
                        setDialogs({
                            ...dialogs,
                            transactionConfirmation: false,
                        });
                        const toSaveVideos: Content[] = videos.map((d) => {
                            if (d.nid === contentId) {
                                return {
                                    ...d,
                                    is_purchased: true,
                                    publish_free: "1",
                                    content_price: 0.0,
                                };
                            } else {
                                return d;
                            }
                        });
                        setGlobalVideos(toSaveVideos);
                        getAvailableCredits();
                        setPurchaseEnabled(false);
                        setIsPurchasingFailed(false);
                    }
                })
                .catch((err) => {
                    setIsPurchasingFailed(true);
                });
        }
        if (paymentMethod === PaymentMethod.CARD) {
            const firebaseEvent: Partial<FirebaseEventAction> = {
                nId: video?.nid,
                contentTitle: video?.title,
                category: EventCategories.VIDEOS,
            };

            purchaseByCard(cart.cartId, 1, video.sku_id, firebaseEvent)
                .then((response) => {
                    if (response?.status) {
                        setDialogs({
                            ...dialogs,
                            transactionConfirmation: false,
                            transactionComplete:
                                activeGiftItem?.giftPurchasedEnabled,
                        });
                        const toSaveVideos: Content[] = videos.map((d) => {
                            if (d.nid === contentId) {
                                return {
                                    ...d,
                                    is_purchased: true,
                                    publish_free: "1",
                                    content_price: 0.0,
                                };
                            } else {
                                return d;
                            }
                        });
                        setGlobalVideos(toSaveVideos);
                        setPurchaseEnabled(false);
                        setIsPurchasingFailed(false);
                    }
                })
                .catch((err) => {
                    setIsPurchasingFailed(true);
                });
        }
    };

    const onBuyConfirm = async () => {
        if (paymentMethod === PaymentMethod.CARD) {
            addToCart(
                activeGiftItem?.giftPurchasedEnabled
                    ? videoGiftSku(activeGiftItem.title)
                    : video.sku_id,
                activeGiftItem?.giftPurchasedEnabled
                    ? activeGiftItem.quantity
                    : 1,
            ).then((response) => {
                if (response?.status) {
                    setDialogs({
                        ...dialogs,
                        transactionConfirmation: true,
                    });
                }
            });
        } else {
            setDialogs({
                ...dialogs,
                transactionConfirmation: true,
            });
        }
    };

    const onGiftMenuItemClick = (item: GiftsTypes, sku: string) => {
        const selectedItem =
            purchasableMemberVideos?.find((x) => x.sku_id === sku) ||
            purchasableProspectVideos?.find((x) => x.sku_id === sku);
        if (selectedItem) {
            setGiftItem(selectedItem);
            setPurchaseEnabled(true);
            setActiveGiftItem({
                title: item,
                giftPurchasedEnabled: true,
                giftPurchasedSuccess: false,
                quantity: 1,
            });
            setAnchorEl(null);
        } else {
            enqueueSnackbar(messaging.common.noAccess, {
                variant: "warning",
            });
        }
    };

    const shortcutGift = () => {
        const giftSku =
            activeGiftItem.title === GiftsTypes.MEMBER
                ? "member_gift_sku" in video && video.member_gift_sku
                : "prospect_gift_sku" in video && video.prospect_gift_sku;
        return {
            ...purchasableMemberVideos?.find((x) => x.sku_id === giftSku),
            sku_id: giftSku,
        };
    };

    const onSendSelectedMembers = async () => {
        if (selectedMembers.length >= 1) {
            const shortcut = shortcutGift();

            if (activeGiftItem.title === GiftsTypes.MEMBER) {
                sendGiftToUser(
                    [
                        {
                            nid: shortcut?.nid,
                            title: shortcut?.title,
                            sku: shortcut?.sku_id,
                            category: EventCategories.GIFT_VIDEOS,
                        },
                    ],
                    selectedMembers,
                    "GiftVideo",
                ).then(() => {
                    fetchQuantity(shortcut?.sku_id);
                    onSendItemsClose();
                });
            }
        } else {
            enqueueSnackbar(messaging?.gifts?.selectAtLeastOneMember, {
                variant: "warning",
            });
        }
    };

    const handleFavouriteClick = (
        e: React.MouseEvent<SVGSVGElement, MouseEvent>,
    ) => {
        const firebaseEvent: Partial<FirebaseEventAction> = {
            nId: video?.nid,
            skuId: video?.sku_id,
            contentTitle: video?.title,
            category: video?.isReceived
                ? EventCategories.GIFT_VIDEOS
                : EventCategories.VIDEOS,
        };

        if (isFavoriteVideo) {
            unMarkFavContentNid(video?.nid, firebaseEvent)
                .then((res) => {
                    if (res?.status) {
                        enqueueSnackbar(messaging.favorites.success, {
                            variant: "success",
                        });
                    } else {
                        enqueueSnackbar(messaging.common.error, {
                            variant: "error",
                        });
                    }
                })
                .catch(() => {
                    enqueueSnackbar(messaging.common.error, {
                        variant: "error",
                    });
                });
        } else {
            markFavContentNid(video?.nid, firebaseEvent)
                .then((res) => {
                    if (res?.status) {
                        enqueueSnackbar(messaging.favorites.success, {
                            variant: "success",
                        });
                    } else {
                        enqueueSnackbar(messaging.common.error, {
                            variant: "error",
                        });
                    }
                })
                .catch(() => {
                    enqueueSnackbar(messaging.common.error, {
                        variant: "error",
                    });
                });
        }
    };

    const handleDelete = async (nid: string) => {
        getDexieConnectionRefresh()
            .videos.delete(`${config.user.memberId}-${nid}`)
            .then((res) => {
                setIsReady(false);
                setIsVideoDownloaded(false);
                setAddedToDownloadQueue(false);
                enqueueSnackbar(messaging.download.deleteSuccess, {
                    variant: "success",
                });
                if (downloadedContentNids && downloadedContentNids.length) {
                    const downloadedNids = [...downloadedContentNids];
                    const updatedDownloadedNids = downloadedNids?.filter(
                        (downloadedNid) =>
                            downloadedNid !== `${config.user.memberId}-${nid}`,
                    );
                    dispatch(
                        setDownloadedContentNids({
                            downloadedContentNids: updatedDownloadedNids,
                        }),
                    );
                }
            })
            .catch((err) => {
                enqueueSnackbar(messaging.download.deleteError, {
                    variant: "error",
                });
            });
        setIsOpenConfirmDailog(!isOpenConfirmDailog);
    };

    const isContentLoaded =
        video &&
        !videosLoading &&
        !receivedMemberVideoGiftsLoading &&
        !receivedProspectVideoGiftsLoading &&
        !loadingProsStatus;

    useEffect(() => {
        if (!!isVideoDownloaded) setIsReady(false);
    }, [isVideoDownloaded]);

    useEffect(() => {
        if (!videoURL || !isVideoDownloaded) {
            const contentURL = isVideoDownloaded
                ? downloadedVideoUrl
                : mediaURL;
            setVideoURL(contentURL);
        }
    }, [isVideoDownloaded, mediaURL]);

    const handleToggleConfirmDialog = () => {
        setIsOpenConfirmDailog(!isOpenConfirmDailog);
    };

    const handleVideoDownload =
        (video: ContentWithMedia | GiftWithMedia) => () => {
            showWarningSnackbarIfRequired();
            setAddedToDownloadQueue(true);
            const downloadingQueueLimit =
                appConstants.downloadingQueue.downloadingQueueLimit;
            const queueLength = getDownloadQueueLength();
            if (queueLength < downloadingQueueLimit) {
                const params: AddToDownloadOptions = {
                    media_url_prefix: media?.media_url_prefix,
                    media_url_postfix: media?.media_url_postfix,
                    media_file_name: media?.media_file_name,
                    name: video.title,
                    type: video.isReceived ? "giftVideo" : "video",
                    nid: video.nid,
                    skuId: video.sku_id,
                    description: video.description,
                    release_date: video.release_date,
                    disclosure: video.disclosure,
                };
                addToDownloadQueue(params);
            } else {
                setQueueLimitReached(true);
                setAddedToDownloadQueue(false);
            }
        };

    const favIconLoading =
        markFavLoading || unMarkFavLoading || favoritesLoading;

    const handleNavigateToQueue = () => {
        const payload = {
            lastVisited: `${location.pathname}${location.search}`,
        };
        setGlobalVideosStack(payload);
        navigate(linkProvider.react.downloadingQueue().index("Video"));
    };

    const toggleQueueLimitReached = () => {
        setQueueLimitReached(!queueLimitReached);
    };

    const { isInsufficeintCredits, isRedeemDisabled } =
        isSufficientCreditAvailable(
            paymentMethod,
            availableCredits,
            activeGiftItem.quantity,
            +giftItem?.number_of_tokens,
        );

    const { downloadStatus, showWarningSnackbarIfRequired } =
        useDownloadingStatusWithSize(mediaSizeBytes);

    const miniplayerOptions = useRef<MiniPlayerOptions>(null);

    useMemo(() => {
        miniplayerOptions.current = {
            mediaUrl: videoURL,
            thumbnail: thumbnail,
            title: video?.title,
            content: video,
            singleLoop: isLoop,
            isPlaying: playing,
            parentLink: getCurrentUrl(),
            contentType: video.isReceived ? "GiftVideo" : "Video",
        };
    }, [videoURL, playing, thumbnail, video, isLoop]);

    const miniPlayerClick = () => {
        const options = miniplayerOptions.current;
        if (options)
            onClickMiniPlayer({
                isAudio: false,
                mediaUrl: options.mediaUrl,
                thumbnail: options.thumbnail,
                title: options.title,
                content: options.content,
                singleLoop: options.singleLoop,
                parentLink: options.parentLink,
                contentType: options.contentType,
            })();
    };
    useEffect(() => {
        return () => {
            if (miniplayerOptions?.current?.isPlaying) miniPlayerClick();
        };
    }, []);

    const playerEnded = () => {
        handleContentCompleted();
        if (isReceivedMemberVideo) logGiftCompleted();
    };

    const handleSequenceEnded = () => {
        const contentJustEnded = !sequence.isDisclosure;
        sequence.handleEnded();
        if (contentJustEnded) playerEnded();
    };

    // a looping element never fires ended, which would strand the sequence
    const sequenceLoop = sequence.isSequencing ? false : isLoop;
    const onBackClick = () => {
        if (!isMixedContent) {
            if (!homeStack?.isHomeTrack) {
                if (isFavoritesTab) {
                    navigate(
                        linkProvider.react.favorites().favoriteVideosListing({
                            scrollTo: scrollTo ? +scrollTo : 0,
                        }),
                    );
                } else if (categoryId === VideoCategoryTitle.INDEX) {
                    navigate(linkProvider.react.videos().index());
                } else {
                    navigate(
                        linkProvider.react.videos().listing(categoryId, {
                            scrollTo: scrollTo ? +scrollTo : 0,
                        }),
                    );
                }
            } else {
                navigate(-1);
            }
        } else {
            navigate(
                linkProvider.react
                    .mixedContent()
                    .index(filePath || null, { scrollTo: scrollTo.toString() }),
            );
        }
    };

    const hasGiftShortcut = useMemo(() => {
        return (
            !!video &&
            "member_gift_sku" in video &&
            (!!video.member_gift_sku || !!video.prospect_gift_sku)
        );
    }, [video]);

    return (
        <Layout
            onBuyClick={onBuyConfirm}
            method={paymentMethod}
            isPurchasing={purchaseEnabled && !dialogs.transactionComplete}
            purchaseEnabled={purchaseEnabled}
            purchaseNavText={purchaseText}
            activeGiftItem={activeGiftItem}
            availableCredits={availableCredits}
            isBuyDisabled={
                purchaseEnabled && activeGiftItem?.giftPurchasedEnabled
                    ? activeGiftItem.quantity < 1 || isRedeemDisabled
                    : false
            }
            dialogs={dialogs}
        >
            <AppHeader
                title={video?.title}
                canGoBack={
                    purchaseEnabled &&
                    activeGiftItem?.giftPurchasedEnabled &&
                    dialogs?.selectMembers
                        ? false
                        : true
                }
                searchable={false}
                onBackClick={onBackClick}
            />

            <Root container className={className} {...rest}>
                {isContentLoaded && (
                    <>
                        <>
                            <Grid
                                item
                                xs={12}
                                display="flex"
                                justifyContent="space-between"
                            >
                                <GreyA100Text fontWeight={"bold"} variant="h6">
                                    {video.title}
                                </GreyA100Text>
                                <WrapperFavAndDownload>
                                    <IconButton>
                                        {favIconLoading ? (
                                            <AppCircularProgress loaderSize="small" />
                                        ) : (
                                            <ActionIcon
                                                onClick={handleFavouriteClick}
                                                icon={[
                                                    isFavoriteVideo
                                                        ? "fas"
                                                        : "far",
                                                    "star",
                                                ]}
                                            />
                                        )}
                                    </IconButton>

                                    {isMediaPlayable &&
                                        !isVideoDownloaded &&
                                        !isInDownloadQueue(video.nid) &&
                                        !addedToDownloadQueue &&
                                        inProgressNid !== video.nid && (
                                            <>
                                                {invalidContentSize(
                                                    sizeOfContent,
                                                ) ||
                                                downloadStatus ===
                                                    DownloadStatus.BLOCK ? (
                                                    <IconButton>
                                                        <DownloadDisabled />
                                                    </IconButton>
                                                ) : (
                                                    <DownloadWarningDialog
                                                        onConfirm={handleVideoDownload(
                                                            video,
                                                        )}
                                                    >
                                                        {(renderProps) => (
                                                            <IconButton
                                                                onClick={
                                                                    renderProps.askConfirmation
                                                                }
                                                            >
                                                                <AppDownloadingIcons iconType="download" />
                                                            </IconButton>
                                                        )}
                                                    </DownloadWarningDialog>
                                                )}
                                            </>
                                        )}
                                    {isVideoDownloaded && (
                                        <IconButton>
                                            <AppDownloadingIcons
                                                iconType="trash"
                                                onClick={
                                                    handleToggleConfirmDialog
                                                }
                                            />
                                        </IconButton>
                                    )}

                                    {!isVideoDownloaded &&
                                        (isInDownloadQueue(video?.nid) ||
                                            addedToDownloadQueue) &&
                                        inProgressNid !== video?.nid && (
                                            <IconButton>
                                                <AppDownloadingIcons
                                                    iconType="queued"
                                                    onClick={
                                                        handleNavigateToQueue
                                                    }
                                                />
                                            </IconButton>
                                        )}
                                    {inProgressNid === video.nid &&
                                        !isVideoDownloaded && (
                                            <IconButton>
                                                <AppDownloadingIcons
                                                    iconType="in-progress"
                                                    onClick={
                                                        handleNavigateToQueue
                                                    }
                                                />
                                            </IconButton>
                                        )}
                                    {isOpenConfirmDailog && (
                                        <AppConfimationDialog
                                            open={isOpenConfirmDailog}
                                            onConfirm={() =>
                                                handleDelete(video.nid)
                                            }
                                            btnConfirmLoader={deleteLoader}
                                            onClose={handleToggleConfirmDialog}
                                            popupMainText="Are you sure you want to delete video?"
                                            confirmText="Delete"
                                            cancelButtonText="Cancel"
                                            showConfirmFirst={true}
                                        />
                                    )}
                                </WrapperFavAndDownload>
                            </Grid>
                            <PurchaseAndSkuInfoGrid content={video} />
                            <Grid item xs={12}>
                                <DisclosureBadge
                                    placement={sequence.step}
                                    mediaNoun="video"
                                />
                            </Grid>
                            <PlayerContainer item xs={12}>
                                {isMediaPlayable &&
                                mediaURL &&
                                mediaURL?.length > 0 ? (
                                    <MediaPlayer
                                        title={video?.title}
                                        mediaURL={sequence.url}
                                        restartToken={sequence.stepToken}
                                        imageURL={thumbnail}
                                        onStart={handleSequenceStarted}
                                        onUpdateExpiredUrl={() =>
                                            setIsReady(false)
                                        }
                                        isAudio={false}
                                        playerRef={playerRef}
                                        progressInterval={
                                            PLAYER_PROGRESS_INTERVAL
                                        }
                                        onReady={onMediaPlayerReady}
                                        onProgress={onPlayerProgress}
                                        loop={sequenceLoop}
                                        onEnded={handleSequenceEnded}
                                        playing={
                                            sequence.playing &&
                                            !miniPlayer.url &&
                                            !disclosure.blocked
                                        }
                                        isDisclosureSource={sequence.isDisclosure}

                                        blockedMessage={blockedMessage}
                                        onError={() => sequence.onError()}
                                        onPlay={handleSequencePlay}
                                        onPause={handleSequencePause}
                                    />
                                ) : thumbnail && thumbnail?.length > 0 ? (
                                    <MediaImage
                                        alt={video?.title}
                                        src={thumbnail}
                                    />
                                ) : (
                                    <DummyImageBox
                                        display={"flex"}
                                        alignItems={"center"}
                                        justifyContent={"flex-end"}
                                    >
                                        <GraphicWrapper>
                                            <GraphicEqIcon
                                                sx={{
                                                    fontSize: "60px",
                                                    color: "grey.400",
                                                }}
                                            />
                                        </GraphicWrapper>
                                    </DummyImageBox>
                                )}
                            </PlayerContainer>
                        </>
                        <Grid
                            item
                            xs={12}
                            display="flex"
                            justifyContent={miniPlayer.url ? "end" : "center"}
                        >
                            {video && isMediaPlayable && (
                                <Box display="flex" justifyContent="center">
                                    <PlayerActionBtns
                                        handleChangeSeek={handleChangeSeek}
                                        isLoop={isLoop}
                                        onClickLoop={() => setLoop(!isLoop)}
                                        onClickMiniPlayer={miniPlayerClick}
                                    />
                                </Box>
                            )}
                            <RenderIf
                                isTrue={
                                    video &&
                                    !purchaseEnabled &&
                                    !video.isReceived &&
                                    !video.is_purchased &&
                                    (video.publish_free === "0" ||
                                        video.publish_free === "false")
                                }
                            >
                                <Grid
                                    item
                                    xs={12}
                                    display="flex"
                                    justifyContent="center"
                                >
                                    <AppButton
                                        onClick={() => setPurchaseEnabled(true)}
                                        buttonVariant="grey-outlined"
                                        rounded
                                    >
                                        BUY
                                    </AppButton>
                                </Grid>
                            </RenderIf>

                            {video &&
                                !video.isReceived &&
                                hasAttachSku(video) &&
                                hasGiftShortcut && (
                                    <ControlIcons>
                                        <GiftSectionWrapper item>
                                            {(quantityLoading ||
                                                videoGiftsLoading) && (
                                                <AppCircularProgress loaderSize="small" />
                                            )}
                                            {!quantityLoading &&
                                                !videoGiftsLoading &&
                                                quantity.memberQuantity > 0 && (
                                                    <>
                                                        <IconButton
                                                            onClick={(e) =>
                                                                setAnchorSendGift(
                                                                    e.currentTarget,
                                                                )
                                                            }
                                                        >
                                                            <ActionIcon
                                                                icon={[
                                                                    "far",
                                                                    "paper-plane",
                                                                ]}
                                                            />
                                                        </IconButton>

                                                        <AppMenuListing
                                                            id="gift-type-send-videos"
                                                            anchorEl={
                                                                anchorSendGift
                                                            }
                                                            open={openSendGift}
                                                            onClose={() =>
                                                                setAnchorSendGift(
                                                                    null,
                                                                )
                                                            }
                                                        >
                                                            <AttachSkuMenu
                                                                skus={convertToAttachSkuArray(
                                                                    (
                                                                        video as ContentWithMedia
                                                                    )
                                                                        ?.member_gift_sku,
                                                                    quantity.memberQuantity,
                                                                    (
                                                                        video as ContentWithMedia
                                                                    )
                                                                        ?.prospect_gift_sku,
                                                                    quantity.prospectQuantity,
                                                                )}
                                                                loaded={
                                                                    !quantityLoading &&
                                                                    !videoGiftsLoading
                                                                }
                                                                onItemClick={
                                                                    onGiftSendMenuItem
                                                                }
                                                            />
                                                        </AppMenuListing>
                                                    </>
                                                )}

                                            <IconButton
                                                sx={
                                                    quantityLoading ||
                                                    videoGiftsLoading
                                                        ? {
                                                              opacity: "50%",
                                                              cursor: "not-allowed !important",
                                                          }
                                                        : undefined
                                                }
                                                onClick={(e) => {
                                                    if (
                                                        quantityLoading ||
                                                        videoGiftsLoading
                                                    ) {
                                                        enqueueSnackbar(
                                                            messaging?.gifts
                                                                ?.fetchingGiftInfo,
                                                            {
                                                                variant:
                                                                    "warning",
                                                            },
                                                        );
                                                    } else {
                                                        setAnchorEl(
                                                            e.currentTarget,
                                                        );
                                                    }
                                                }}
                                            >
                                                <ActionIcon
                                                    icon={["fas", "gift"]}
                                                />
                                            </IconButton>

                                            <AppMenuListing
                                                id="gift-type-menu-videos"
                                                anchorEl={anchorEl}
                                                open={open}
                                                onClose={() =>
                                                    setAnchorEl(null)
                                                }
                                            >
                                                <AttachSkuMenu
                                                    skus={convertToAttachSkuArray(
                                                        (
                                                            video as ContentWithMedia
                                                        )?.member_gift_sku,
                                                        quantity.memberQuantity,
                                                        (
                                                            video as ContentWithMedia
                                                        )?.prospect_gift_sku,
                                                        quantity.prospectQuantity,
                                                    )}
                                                    loaded={!quantityLoading}
                                                    onItemClick={
                                                        onGiftMenuItemClick
                                                    }
                                                />
                                            </AppMenuListing>
                                        </GiftSectionWrapper>
                                    </ControlIcons>
                                )}
                        </Grid>
                        {video && !purchaseEnabled && (
                            <>
                                <Grid item xs={12}>
                                    <DateText variant="body2">
                                        {moment
                                            .unix(+video?.release_date)
                                            .format("LL")}
                                    </DateText>
                                </Grid>
                                <DescriptionOverflow item xs={12}>
                                    <Grey800Text variant="body2">
                                        {video?.description}
                                    </Grey800Text>
                                </DescriptionOverflow>
                            </>
                        )}
                        {purchaseEnabled && !dialogs?.selectMembers && (
                            <ContentPurchase
                                marginBottom={"30px"}
                                onBackClick={() => {
                                    setPurchaseEnabled(false);
                                    setActiveGiftItem({
                                        title: GiftsTypes.DEFAULT,
                                        giftPurchasedEnabled: false,
                                        giftPurchasedSuccess: false,
                                        quantity: 1,
                                    });
                                }}
                                buying={
                                    purchasingContent ||
                                    redeemingContent ||
                                    redeemingGiftContent
                                }
                                cart={cart}
                                backTitle={
                                    activeGiftItem?.giftPurchasedEnabled
                                        ? activeGiftItem?.title
                                        : "Video Purchase"
                                }
                                credits={availableCredits}
                                availableCreditsLoading={
                                    availableCreditsLoading
                                }
                                requiredCredits={
                                    activeGiftItem?.giftPurchasedEnabled
                                        ? `${giftItem?.number_of_tokens}`
                                        : `${video?.number_of_tokens}`
                                }
                                method={paymentMethod}
                                activeGiftItem={activeGiftItem}
                                onSendContent={onSendContent}
                                selectedMembers={selectedMembers}
                                totalPrice={(activeGiftItem.giftPurchasedEnabled
                                    ? getValidNumber(giftItem?.content_price)
                                    : getValidNumber(video?.content_price)
                                ).toFixed(2)}
                                contentPrice={
                                    activeGiftItem?.giftPurchasedEnabled
                                        ? getValidNumber(
                                              giftItem?.content_price,
                                          )
                                        : getValidNumber(video?.content_price)
                                }
                                onMethodChange={(method) => {
                                    if (method === PaymentMethod.MY_CREDITS) {
                                        if (
                                            (activeGiftItem.giftPurchasedEnabled &&
                                                giftItem?.is_redeemable_by_tokens) ||
                                            (!activeGiftItem.giftPurchasedEnabled &&
                                                video?.is_redeemable_by_tokens)
                                        ) {
                                            setPaymentMethod(method);
                                        } else {
                                            enqueueSnackbar(
                                                messaging?.redeeming
                                                    ?.notRedeemable,
                                                { variant: "warning" },
                                            );
                                        }
                                    }

                                    if (method === PaymentMethod.CARD) {
                                        setPaymentMethod(method);
                                    }
                                }}
                                dialogs={dialogs}
                                setDialogs={setDialogs}
                                onBuy={onBuyContent}
                                onBuyGift={onBuyGiftContent}
                                isRedemeableByToken={
                                    activeGiftItem.giftPurchasedEnabled
                                        ? giftItem?.is_redeemable_by_tokens
                                        : video?.is_redeemable_by_tokens
                                }
                                onCloseConfirmDialog={onCloseSelectMembers}
                                quantityLoading={quantityLoading}
                                isPurchasingFailed={isPurchasingFailed}
                            />
                        )}
                        {purchaseEnabled &&
                            activeGiftItem?.giftPurchasedEnabled &&
                            !dialogs?.selectMembers && (
                                <GiftQuantity
                                    activeGiftItem={activeGiftItem}
                                    onQuantityChange={onQuantityChange}
                                    method={paymentMethod}
                                    credits={availableCredits}
                                    isInsufficeintCredits={
                                        isInsufficeintCredits
                                    }
                                />
                            )}
                        {purchaseEnabled &&
                            activeGiftItem?.giftPurchasedEnabled &&
                            dialogs?.selectMembers && (
                                <SelectMembersDialog
                                    open={true}
                                    searchable={true}
                                    searchPlaceholder="Search by name or LTD ID"
                                    searchQuery={searchQueryLos}
                                    setSearchQuery={setSearchQueryLos}
                                    selectedMembers={selectedMembers}
                                    checkboxList={searchLosResults}
                                    onToggleItemSelect={onToggleItemSelect}
                                    onClose={onCloseSelectMembers}
                                    onSend={onSendSelectedMembers}
                                    giftSendLoading={sendingGifts}
                                    availableQuantity={
                                        activeGiftItem?.quantity -
                                            selectedMembers?.length >
                                        0
                                            ? activeGiftItem?.quantity -
                                              selectedMembers?.length
                                            : 0
                                    }
                                />
                            )}
                        {queueLimitReached && (
                            <AppConfimationDialog
                                titleText={
                                    messaging?.downloadingQueue?.QueueLimitation
                                }
                                showTitle={true}
                                open={queueLimitReached}
                                popupMainText={
                                    messaging?.downloadingQueue?.limitReached
                                }
                                cancelButtonText="OK"
                                onClose={toggleQueueLimitReached}
                            />
                        )}
                    </>
                )}
                {(!isContentLoaded || detailLoading) && (
                    <AppBackdropProgress
                        open={true}
                        backdropText={messaging.loader.video}
                    />
                )}
                {favIconLoading && (
                    <AppBackdropProgress
                        open={true}
                        backdropText={messaging.loader.processing}
                    />
                )}
            </Root>
        </Layout>
    );
};

const useQueryParams = () => {
    const location = useLocation();

    return useMemo(() => {
        const parsedQueryString = qs.parse(location.search, {
            ignoreQueryPrefix: true,
        });

        const {
            isMixedContent = false,
            scrollTo = "0",
            filePath = "",
        } = parsedQueryString;

        return {
            isMixedContent: !!isMixedContent ? true : false,
            scrollTo: scrollTo,
            filePath: filePath.toString(),
        };
    }, [location?.search]);
};

const Root = styled(Grid)(({ theme }) => ({
    padding: theme.spacing(2),
}));

const Grey500Text = styled(Typography)(({ theme }) => ({
    color: theme.palette.grey[500],
}));

const Grey800Text = styled(Typography)(({ theme }) => ({
    color: theme.palette.grey[800],
}));

const GreyA100Text = styled(Typography)(({ theme }) => ({
    color: theme.palette.grey.A100,
}));

const PlayerContainer = styled(Grid)(({ theme }) => ({
    margin: theme.spacing(2, 0),
    height: "60vh",
    [theme.breakpoints.down("lg")]: {
        height: "50vh",
    },
    [theme.breakpoints.down("sm")]: {
        height: "30vh",
    },
}));

const GraphicIcon = styled("span")(({ theme }) => ({
    color: theme.palette.grey[400],
}));

const GraphicWrapper = styled("span")(({ theme }) => ({
    border: `5px solid ${theme.palette.common.white}`,
    borderRadius: "50%",
    height: "120px",
    width: "120px",
    marginRight: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));

const DummyImageBox = styled(Box)(({ theme }) => ({
    background: theme.palette.grey[900],
    height: "100%",
}));

const MediaImage = styled("img")(({ theme }) => ({
    width: "100%",
    height: "100%",
    objectFit: "contain",
    background: theme.palette.common.black,
}));

const DateText = styled(Typography)(({ theme }) => ({
    color: theme.palette.grey[500],
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
}));

const GiftSectionWrapper = styled(Grid)({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
});

const DescriptionOverflow = styled(Grid)({
    overflowWrap: "break-word",
});

const WrapperFavAndDownload = styled("div")({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
});

const ControlIcons = styled(Box)({
    minWidth: "40px",
    display: "flex",
});

const giftIconButtonDisabledStyle = {
    opacity: "50%",
    cursor: "not-allowed !important",
};

export interface VideoContentDetailProps
    extends InternalStandardProps<GridProps> {}
